export function formattedCPF(num: string) {
  return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formattedCard(num: any) {
  return num.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
}

export function addPhoneNumberPattern(phoneNumber: string) {
  return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}

export function dataBirthDayPattern(data: string) {
  return data.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
}

export function isEmail(email: string) {
  const value =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return value.test(String(email).toLowerCase());
}
